/* eslint-disable @typescript-eslint/no-explicit-any */

export const noop: (...args: any[]) => void = () => undefined;
